// src/components/taskComments/TaskCommentIndex.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import { TaskCommentsForm } from './TaskCommentsForm';
import { TaskCommentsList } from './TaskCommentsList';
import AboutSection from '../AboutSection';

const isAdmin = true;

const TaskCommentFormWrapper: React.FC = () => {
  const location = useLocation();
  const { taskId = '' } = useParams(); // get taskId from the URL or fallback

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (location.pathname.endsWith('/create')) mode = 'create';
  else if (location.pathname.endsWith('/edit')) mode = 'edit';

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`Task Comments - ${mode}`} iconName="comments" />
      <TaskCommentsForm mode={mode} taskId={taskId} />
    </div>
  );
};

const TaskCommentsModule: React.FC = () => {
  const { taskId = '' } = useParams(); // Assume taskId is part of route

  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<TaskCommentsList taskId={taskId} />} />
      <Route path="list" element={<TaskCommentsList taskId={taskId} />} />
      <Route path="create" element={<TaskCommentFormWrapper />} />
      <Route path=":id" element={<TaskCommentFormWrapper />} />
      <Route path=":id/edit" element={<TaskCommentFormWrapper />} />
    </Routes>
  );
};

export default TaskCommentsModule;